import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CotizarComponent } from "./cotizar/cotizar.component";
import { CategoriasComponent } from "./cotizar/components/categorias/categorias.component";

import { RouterModule } from "@angular/router";
import { MatTreeModule } from "@angular/material/tree";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatListModule } from "@angular/material/list";
import { MatInputModule } from "@angular/material/input";
import { FuseSearchBarModule, FuseSidebarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { TablaServiciosComponent } from "./cotizar/components/tabla-servicios/tabla-servicios.component";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDialogModule } from "@angular/material/dialog";
import { DialogAgregarServicioComponent } from "./cotizar/components/dialog-agregar-servicio/dialog-agregar-servicio.component";
import { ServiciosSeleccionadosComponent } from "./cotizar/components/servicios-seleccionados/servicios-seleccionados.component";
import { ServiciosComplementariosComponent } from "./cotizar/components/servicios-complementarios/servicios-complementarios.component";
import { MatMenuModule } from "@angular/material/menu";
import { DialogAgregarServicioComplementarioComponent } from "./cotizar/components/dialog-agregar-servicio-complementario/dialog-agregar-servicio-complementario.component";
import { MatToolbarModule } from "@angular/material/toolbar";
import { CotizacionesComponent } from "./cotizaciones/cotizaciones.component";
import { TablaCotizacionesComponent } from "./cotizaciones/components/tabla-cotizaciones/tabla-cotizaciones.component";
import { DetalleCotizacionComponent } from "./detalle-cotizacion/detalle-cotizacion.component";
import { ServiciosCotizacionComponent } from "./detalle-cotizacion/components/servicios-cotizacion/servicios-cotizacion.component";
import { DialogSolicitarServicioComponent } from "./detalle-cotizacion/components/dialog-solicitar-servicio/dialog-solicitar-servicio.component";
import { DialogDetalleServicioComponent } from "./detalle-cotizacion/components/dialog-detalle-servicio/dialog-detalle-servicio.component";
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../shared/services/auth/role-guard.service";
import { DialogCotizarServicioComponent } from "./detalle-cotizacion/components/dialog-cotizar-servicio/dialog-cotizar-servicio.component";
import { DialogActualizarVigenciaComponent } from "./cotizaciones/components/dialog-actualizar-vigencia/dialog-actualizar-vigencia.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { DialogAdjuntoComponent } from "./detalle-cotizacion/components/dialog-adjunto/dialog-adjunto.component";
import { DialogRechazarServicioComponent } from "./detalle-cotizacion/components/dialog-rechazar-servicio/dialog-rechazar-servicio.component";
import { FiltroCotizacionComponent } from "./cotizaciones/components/filtro-cotizacion/filtro-cotizacion.component";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { DialogContratistasComponent } from "./detalle-cotizacion/components/dialog-contratistas/dialog-contratistas.component";
import { ListadoContratistasComponent } from "./detalle-cotizacion/components/listado-contratistas/listado-contratistas.component";
import { ListadoInvitacionesContratistasComponent } from "./detalle-cotizacion/components/listado-invitaciones-contratistas/listado-invitaciones-contratistas.component";
import { DialogInvitarComponent } from "./detalle-cotizacion/components/dialog-invitar/dialog-invitar.component";
import { SharedModule } from "../shared/shared/shared.module";

const routes = [
    {
        path: "cotizar",
        component: CotizarComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [4],
        },
    },
    {
        path: "cotizaciones",
        component: CotizacionesComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
    {
        path: "cotizaciones/:idCotizacion",
        component: DetalleCotizacionComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1, 3, 4],
        },
    },
];

@NgModule({
    declarations: [
        CotizarComponent,
        CotizacionesComponent,
        CategoriasComponent,
        TablaServiciosComponent,
        DialogAgregarServicioComponent,
        ServiciosSeleccionadosComponent,
        ServiciosComplementariosComponent,
        DialogAgregarServicioComplementarioComponent,
        TablaCotizacionesComponent,
        DetalleCotizacionComponent,
        ServiciosCotizacionComponent,
        DialogSolicitarServicioComponent,
        DialogDetalleServicioComponent,
        DialogCotizarServicioComponent,
        DialogActualizarVigenciaComponent,
        DialogAdjuntoComponent,
        DialogRechazarServicioComponent,
        FiltroCotizacionComponent,
        DialogContratistasComponent,
        ListadoContratistasComponent,
        ListadoInvitacionesContratistasComponent,
        DialogInvitarComponent,
    ],
    imports: [
        RouterModule.forChild(routes),

        CommonModule,
        MatDatepickerModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        MatListModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDialogModule,
        MatMenuModule,
        FuseSidebarModule,
        FuseSharedModule,
        FormsModule,
        ReactiveFormsModule,
        MatToolbarModule,
        FuseSearchBarModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatAutocompleteModule,
        SharedModule,
    ],
    entryComponents: [
        DialogAgregarServicioComplementarioComponent,
        DialogAgregarServicioComponent,
    ],
})
export class CotizacionModule {}
